import type { ModuleItem } from "../lib/modulesData";

export const ECOSYSTEM_LINKS = {
  extensions: "/platform/modules",
  platforms: "/platforms",
  store: "/store",
};

export const ECOSYSTEM_PLATFORMS = [
  {
    id: "vote",
    name: "VCENTRE.VOTE",
    status: "Доступно",
    description:
      "Премии, конкурсы и профессиональные голосования: номинации, профили номинантов и жюри, критерии, оценки и результаты.",
    price: "от 2 890 ₽ / мес.",
    prices: { "1": 3490, "6": 3190, "12": 2890 },
    href: "https://vote.vcentre.pro",
    note: "Работает самостоятельно. Интеграция с ONE — отдельное расширение и требует активной подписки VOTE.",
  },
  {
    id: "finance",
    name: "VCENTRE.FINANCE",
    status: "Скоро",
    description:
      "Финансовый контур владельца и команды: доходы, расходы, ДДС, бюджеты, прогноз, дебиторка, кредиторка, проекты и финансовые точки внимания.",
    price: "ориентир — от 7 990 ₽ / мес.",
    href: null,
    note: "Окончательные условия будут объявлены к запуску.",
  },
  {
    id: "content",
    name: "VCENTRE.CONTENT",
    status: "Скоро",
    description:
      "AI-платформа для текстов, постов, статей, изображений и материалов бизнеса.",
    price: "0 ₽ за базовую подписку",
    href: null,
    note: "AI-функции расходуют единый AI-баланс VCENTRE.",
  },
  {
    id: "jurist",
    name: "VCENTRE.JURIST",
    status: "Скоро",
    description:
      "AI-инструменты для анализа договоров, сравнения редакций и подготовки юридических документов.",
    price: "0 ₽ за базовую подписку",
    href: null,
    note: "AI-функции расходуют единый AI-баланс VCENTRE.",
  },
];

export const STORE_RESOURCES = [
  {
    id: "ai-balance",
    name: "AI-баланс",
    description:
      "Единый баланс аккаунта VCENTRE для AI-функций ONE, CONTENT, JURIST, AI-Маскота и других поддерживаемых продуктов.",
    note: "ONE ежемесячно включает эквивалент $1 / $5 / $7 / $10 по тарифу. Условия дополнительного пополнения уточняются при оформлении.",
    action: "Уточнить пополнение",
  },
  {
    id: "cloud",
    name: "VCENTRE Cloud",
    description:
      "Дополнительное облачное место на уровне аккаунта для поддерживаемых платформ экосистемы.",
    note: "Встроенное хранилище ONE сохраняется. Стоимость дополнительных ГБ уточняется отдельно.",
    action: "Уточнить объём и стоимость",
  },
  {
    id: "domains",
    name: "Доменные имена",
    description: "Домены для сайта, фирменной почты и других сервисов VCENTRE.",
    note: "Регистрация и продление на год. Цена зависит от выбранного домена; периоды 1/6/12 месяцев к нему не применяются.",
    action: "Подобрать домен",
  },
  {
    id: "ai-subscriptions",
    name: "AI-подписки",
    description:
      "Специализированные AI-помощники и дополнительные AI-сервисы поверх общего баланса.",
    note: "Скоро. Условия будут опубликованы при запуске.",
    action: null,
  },
];

const rates = {
  S: { "1": 1990, "6": 1790, "12": 1590 },
  M: { "1": 2990, "6": 2690, "12": 2390 },
  L: { "1": 4490, "6": 3990, "12": 3490 },
  XL: { "1": 6990, "6": 6290, "12": 5590 },
  XXL: { "1": 9990, "6": 8990, "12": 7990 },
};

export type Extension = ModuleItem & {
  monthlyPrices: Record<"1" | "6" | "12", number>;
  status: "live" | "soon";
  purchasable: boolean;
};

function extension(
  id: string,
  title: string,
  tier: keyof typeof rates,
  category: string,
  description: string,
  features: string[],
  example: string,
  live = false,
  includes: string[] = [],
): Extension {
  return {
    id,
    title,
    price: rates[tier]["1"],
    monthlyPrices: rates[tier],
    category,
    tags: [],
    shortDescription: description,
    fullDescription: description,
    features,
    example,
    status: live ? "live" : "soon",
    purchasable: live,
    includes,
  };
}

export const EXTENSIONS: Extension[] = [
  {
    ...extension(
      "additional-site",
      "Дополнительный сайт",
      "M",
      "sales",
      "Ещё один полноценный сайт в контуре VCENTRE.ONE — со своей административной панелью, контентом и аналитикой, но с общей CRM, клиентской базой и данными платформы.",
      ["Собственный сайт и домен", "Полноценная административная панель", "Страницы, контент и каталог", "Формы, заявки и заказы", "Аналитика и остальные стандартные возможности сайта", "Общие CRM, клиенты и данные VCENTRE.ONE"],
      "Бизнес запускает ещё один сайт для отдельного направления и ведёт его клиентов и заявки в общей CRM.",
    ),
    availablePlans: ["PRO+", "GENIUS"],
  },
  extension(
    "email",
    "Фирменная почта",
    "S",
    "marketing",
    "Системные письма VCENTRE.ONE с вашего собственного домена: коды авторизации, подтверждения, уведомления и сервисные сообщения. Домен приобретается отдельно.",
    [
      "Письма от имени бизнеса",
      "Подтверждения и уведомления",
      "Билеты и сервисные письма",
      "Email-коммуникации",
    ],
    "Клиент получает подтверждение регистрации и билет с почтового домена организатора.",
    true,
  ),
  extension(
    "networking",
    "Цифровая визитка",
    "M",
    "engagement",
    "Знакомства через QR или ссылку и собственная записная книжка контактов внутри приложения.",
    [
      "QR и персональная ссылка",
      "Профиль человека",
      "Сохранение контактов",
      "Мессенджер приложения",
    ],
    "Участник конференции сканирует QR визитки, сохраняет контакт и продолжает общение в приложении.",
    true,
  ),
  extension(
    "library",
    "Электронная библиотека",
    "M",
    "education",
    "Книги и длинные материалы с полноценным чтением прямо внутри приложения.",
    [
      "Обложка, автор и содержание",
      "Главы и онлайн-чтение",
      "Позиция и прогресс чтения",
      "Закладки, коллекции и доступы",
    ],
    "Компания публикует библиотеку материалов, а читатель возвращается к сохранённой позиции.",
  ),
  extension(
    "online",
    "Сообщество",
    "L",
    "engagement",
    "Своя социальная среда: профили, знакомства, связи и общение внутри приложения. Включает функциональную основу Цифровой визитки.",
    [
      "Каталог людей и фильтры",
      "Запросы на знакомство",
      "Подтверждение связей",
      "Мессенджер и закрытые сообщества",
    ],
    "Деловой клуб объединяет участников по интересам и сохраняет связи внутри своего приложения.",
    true,
    ["networking"],
  ),
  extension(
    "ai-mascot",
    "AI-Маскот",
    "L",
    "ai",
    "Анимированный AI-персонаж на сайте: открывает диалог и отвечает в визуальном образе бренда. AI расходует единый баланс VCENTRE; индивидуальная разработка персонажа оценивается отдельно.",
    [
      "Анимированный персонаж",
      "Диалог с посетителем",
      "Образ бренда",
      "Единый AI-баланс",
    ],
    "Маскот отвечает на вопросы о компании и помогает посетителю найти нужную услугу.",
  ),
  extension(
    "auction",
    "Аукцион",
    "L",
    "sales",
    "Торги за товары и слоты внутри собственного приложения. 0% комиссии VCENTRE.ONE с результата аукциона; комиссии платёжных провайдеров применяются отдельно.",
    [
      "Стартовая цена и срок торгов",
      "Лучшая ставка и повышение",
      "История ставок",
      "Победитель и закрытие торгов",
    ],
    "Участники повышают ставки до окончания таймера, после чего система определяет победителя.",
  ),
  extension(
    "tickets",
    "Билеты и события",
    "XL",
    "sales",
    "Своя афиша, платные билеты, бесплатные регистрации и цифровой вход. 0% комиссии VCENTRE.ONE с продажи билетов; комиссии эквайринга применяются отдельно.",
    [
      "Афиша и карточки мероприятий",
      "Типы билетов и бесплатная регистрация",
      "QR-билет, сканер и проверка доступа",
      "Посещения, CRM и уведомления",
    ],
    "Организатор продаёт билеты и принимает бесплатные регистрации, а на входе сотрудники проверяют QR со смартфона.",
    true,
  ),
  extension(
    "tender",
    "Tender — совместная закупка",
    "XXL",
    "sales",
    "Совместная закупка и маркетплейс заявок внутри вашего приложения. Запрос попадает подходящим исполнителям, заказчик сравнивает предложения и выбирает партнёра.",
    [
      "Категории и обезличенные запросы",
      "Ответы и коммерческие предложения",
      "Профили исполнителей",
      "Каталог предложений и доска объявлений",
    ],
    "Заказчик публикует запрос, получает предложения подрядчиков и продолжает общение с выбранным исполнителем.",
    true,
  ),
  extension(
    "vote",
    "Интеграция VCENTRE.VOTE",
    "S",
    "engagement",
    "Связь премии или голосования с приложением, сайтом и CRM VCENTRE.ONE. Это отдельное расширение; для работы нужна активная подписка платформы VCENTRE.VOTE.",
    [
      "Заявки через приложение и сайт",
      "Единая авторизация и профиль",
      "Номинации, участники и результаты",
      "Уведомления и CRM",
    ],
    "Организатор использует VOTE для оценки заявок, а ONE — для общения с участниками.",
    true,
  ),
];

export const EXTENSION_BILLING_NOTE =
  "Расширения оплачиваются на 1, 6 или 12 месяцев. При подключении позже тарифа оплачивается оставшийся период. Такой расчёт и переход с Цифровой визитки на Сообщество уточняются при оформлении; автоматический перерасчёт пока не подключён.";
